var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForwardarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 6.3894C4.35782e-06 5.83711 0.447723 5.3894 1.00001 5.38941L11.3135 5.38948L7.63111 1.70711C7.24058 1.31658 7.24058 0.683418 7.63111 0.292893C8.02163 -0.0976311 8.6548 -0.0976312 9.04532 0.292893L14.4348 5.6824C14.8253 6.07292 14.8253 6.70608 14.4348 7.09661L9.04532 12.4861C8.6548 12.8766 8.02163 12.8766 7.63111 12.4861C7.24058 12.0956 7.24058 11.4624 7.63111 11.0719L11.3135 7.38948L0.999993 7.38941C0.447708 7.3894 -4.37883e-06 6.94168 0 6.3894Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardarrow);
export default __webpack_public_path__ + "static/media/forwardarrow.d93bf31f998168bef64a42e43b2b55ef.svg";
export { ForwardRef as ReactComponent };